










import Vue from 'vue';
import SettingWrapper from '../setting-wrapper.component.vue';

export default Vue.extend({
  name: 'ManageBeneficiaries',
  props: {
    accountType: {
      type: String,
      required: true,
    },
    accountId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    beneficiariesCount(): number {
      return this.$store.getters.beneficiaryQuantity(this.accountId);
    },
    beneficiariesCountLabel(): string {
      return this.beneficiariesCount === 1
        ? this.$options.filters.t([
            'account-settings_label_beneficiary',
            'global_beneficiary',
          ])
        : this.$options.filters.t([
            'account-settings_label_beneficiaries',
            'global_beneficiaries',
          ]);
    },
  },
  components: {
    SettingWrapper,
  },
});
